import ajax from './ajax';

export function getFrontendSettings() {
  return ajax('/GernalSetting?SettingsSearch[module_name]=frontend&per-page=200');
}
